<!-- Loading -->
<div
  class="gd-spreadsheet-editor-v2-loading">
  <mat-progress-spinner
    mode="indeterminate"
    diameter="32"></mat-progress-spinner>
</div>
